<!-- <span id="back">
    <a class="nav-link sign" routerLink="/lobby" title="Back" role="button">
        BACK</a>
</span> -->

<section>
    <div class="content-wrap">
        <div id="bg">
            <img src="assets/event/archive.jpg" alt="">
            <div class="container-fluid" style="position: absolute;
            height: 90vh;
            overflow: scroll;
            top: 2%;
            left: 0%;">
                <div class="row" >
                    <div class="col-md-3 col-sm-4" *ngFor="let a of quizlist">
                        <div class="content">
                            <!-- <a class="lightbox" href="#dog">
                                <img src="http://i.huffpost.com/gen/749263/original.jpg"/>
                             </a> 
                             <div class="lightbox-target" id="dog">
                                <img src="http://i.huffpost.com/gen/749263/original.jpg"/>
                                <a class="lightbox-close" href="#"></a>
                             </div> -->
                            <div class="entry_img">
                                <img style="height: 22vh !important;cursor: pointer;" src="{{a.image_path}}" class="img-fluid zoom" alt="" (click)="openModal(a.image_path)" >
                            </div>
                            <div class="entry_cnt">
                                <p class="font-weight-bold mb-0">{{a.emp_id}}</p>

                                <p class="font-weight-bold mb-0">{{a.name | titlecase}}</p>
                                <p class="mb-0">{{a.location | titlecase}}</p>
                                <p class="mb-0 font-weight-bold">{{a.cat | titlecase}}</p>
                                
                                <div class="vote">
                                    <div *ngFor="let b of help">
                                        <h4 class="font-weight-bold mb-0" *ngIf="a.id == b.to_id"> {{b.count}}</h4>
                                    </div>
                                    <button class="btn" (click)="vote(a.image_path, a.id)">Like</button>
                                </div>
                            </div>
                        </div> 
                    </div>
                    

                </div>
            </div>

        </div>
    </div>
</section>

<div class="modal fade" id="bubbleShoot" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="container-fluid" id="popup">
                <div class="row">
                    <div class="col-md-12 col-xl-12">
                        <div class="chat_section">
                            <div class="popup_header">
                                <h6>Bubble Shooter</h6>
                                <a class="close" (click)="closePopup()"></a>
                            </div>
                            <div class="container-fluid" style="background: #c5c5c5;">
                                <div class="row">
                                    <div class="col-md-12 col-xl-12 p-0" style="text-align: center;">
                                        <div class="row">
                                        </div>
                                        <iframe
                                            src="https://previews.customer.envatousercontent.com/files/266349013/index.html"
                                            width="100%" height="615" frameborder="0"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="bikeRacing" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="container-fluid" id="popup">
                <div class="row">
                    <div class="col-md-12 col-xl-12">
                        <div class="chat_section">
                            <div class="popup_header">
                                <h6>ArtCart Entry</h6>
                                <a class="close" style="cursor: pointer;" (click)="closePopup()"></a>
                            </div>
                            <div class="container-fluid" style="background: #c5c5c5;">
                                <div class="row">
                                    <div class="col-md-12 col-xl-12 p-0" style="text-align: center;">
                                        <div class="row">
                                        </div>
                                        <img style="width:100%"
                                            [src]="this.src"
                                             frameborder='0'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>